import {Branding} from "../../types/Branding";
import {Comparator} from "../../types/GenericTypes";
import {NavigationItem, NavigationItems} from "../models/NavigationItems";

export default function(branding: Branding, items: NavigationItems): NavigationItems {
    switch (branding) {
        case Branding.ALLFIN:
            return [...items].sort(allFinSorting());
        default:
            return items;
    }
}

function allFinSorting(): Comparator<NavigationItem> {

    const sorting = [
        "portfolio",
        "performance",
        "trading-dashboard",
        "orders",
        "company-info",
        "stock-screener",
        "charting"
    ];

    return (a, b) => {
        const aIndex = sorting.indexOf(a.name);
        if (aIndex === -1) {
            return 1;
        }

        const bIndex = sorting.indexOf(b.name);
        if (bIndex === -1) {
            return -1;
        }

        return aIndex - bIndex;
    };
}
